import gql from 'graphql-tag';

export const UserChangePasswordMutation = gql`
	mutation UserChangePasswordMutation($id: ID!, $newPassword: String!) {
		 userChangePassword(id: $id, newPassword: $newPassword)
	}
`;


